<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 11:42:32
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-30 18:05:47
-->
<template>
	<div class="searchBox">
		<div>
			<el-form inline :model="form" label-width="96px">
				<el-form-item label="用户名称">
					<el-input v-model="form.nickname" clearable placeholder="请输入" style="width: 240px"></el-input>
				</el-form-item>
				<el-form-item label="手机号码">
					<el-input v-model="form.mobile" clearable placeholder="请输入" style="width: 240px"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-select v-model="form.roleId" clearable placeholder="请选择" style="width: 240px">
						<el-option :label="item.name" :value="item.id" v-for="item in roleList" :key="item.id" />
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="账号状态">
					<el-select v-model="form.status" clearable placeholder="请选择" style="width:180px">
						<el-option label="正常" value="0" />
						<el-option label="已离职" value="1" />
					</el-select>
				</el-form-item> -->

				<el-form-item label="创建时间">
					<el-date-picker
						v-model="createTime"
						type="daterange"
						@change="changTime($event)"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始"
						end-placeholder="结束"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getUsersList" class="ml-20">搜索</el-button>
					<el-button @click="onClear">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { getRoleDownList } from '@/api/teamManage';
export default {
	data() {
		return {
			form: {
				nickname: '',
				mobile: '',
				roleId: '',
				status: '',
				beginTime: '',
				endTime: '',
			},
			createTime: '',
			roleList: [],
		};
	},
	components: {},

	created() {
		this.getRoleDownList();
	},

	methods: {
		getUsersList() {
			// this.form.deptId = this.deptId;
			// console.log(444);
			this.$emit('getUsersList', this.form);
		},
		//获取角色选择器下拉列表
		async getRoleDownList() {
			const roleList = await getRoleDownList();
			this.roleList = roleList;
		},
		changTime(val) {
			if (!val) return;
			this.form.beginTime = val[0] + ' 00:00:00';
			this.form.endTime = val[1] + ' 23:59:59';
		},
		onClear() {
			this.form = {
				nickname: '',
				mobile: '',
				roleId: '',
				status: '',
				beginTime: '',
				endTime: '',
			};
			this.createTime = '';
			this.getUsersList();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-date-editor--daterange.el-input__inner {
	width: 240px;
	.el-range-input {
		margin-left: 4px;
	}
}
</style>
